import styled from "styled-components";

export const Container = styled.div`
  display:flex;
  flex-direction:column;
  width:100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  gap: 10px;
  padding: 20px 10px 0px 0px;

  @media screen and (max-width: 900px) {
    padding-right: 0;
  }
`
